export default function () {
    alert('该方法弃用！，请使用wxApi.share方法')
}
